import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { SnackbarService } from './snackbar.service';
import { LocalStorageService } from './local-storage.service';
import { URLPaths } from '../utilities/urlPaths.config';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {
  private static _staticSnackbarService: SnackbarService | null = null;

  constructor(
    private _router: Router,
    private _snackbarService: SnackbarService
  ) {
    ErrorHandlerService._staticSnackbarService = _snackbarService;
  }

  // Handle login exception and other API errors
  handleError = (error: any): Observable<never> => {
    const hasToken = !!LocalStorageService.getLocalStorageValueBasedOnKeys('MSAL_JWT_TOKEN');
    const isAuthOrSessionError =
      !hasToken ||
      error?.status === 401 ||
      error?.status === 403 ||
      error?.status === 0 ||
      error?.message?.includes('token refresh') ||
      error?.message?.includes('session has expired');

    if (!isAuthOrSessionError) {
      let errorMessage = error?.statusText || (typeof error?.message === 'string' ? error.message : 'Unknown Error');
      if (error?.error?.['Message']) {
        errorMessage += ' - ' + error.error['Message'];
      } else if (error?.error?.['detail']) {
        errorMessage += ' - ' + error.error['detail'];
      }

      const snackbar = this?._snackbarService || ErrorHandlerService._staticSnackbarService;
      snackbar?.showSnackBar(errorMessage, 'close', 'failure');
    }

    return throwError(() => error);
  };
}
